import "../Styles/Legal.css";
import Footer from "./Footer";
import Header from "./Header";

function Terms() {
  return (
    <>
   <Header/>
    <div className="legal">
      <div className="legal-container">
        <h1>Terms and Conditions</h1>

        <p className="date">Effective Date: 25 June 2026</p>

        <p>
          By using Cluster Clear, you agree to these Terms and Conditions. If
          you do not agree, you should not use our platform.
        </p>

        <h2>Our Service</h2>

        <p>
          Cluster Clear helps businesses create digital profiles and QR codes
          that allow customers to access business information, social media
          links, reviews, contact details and other online resources.
        </p>

        <h2>User Responsibilities</h2>

        <p>
          You agree to provide accurate information, use the platform lawfully
          and avoid uploading harmful, misleading, illegal or offensive content.
        </p>

        <h2>Prohibited Use</h2>

        <p>
          You must not use Cluster Clear to promote illegal activities,
          distribute spam or malware, impersonate another person or business, or
          violate intellectual property rights.
        </p>

        <h2>Service Availability</h2>

        <p>
          We aim to keep Cluster Clear available and reliable, but we cannot
          guarantee uninterrupted or error-free access at all times.
        </p>

        <h2>Limitation of Liability</h2>

        <p>
          Cluster Clear is provided on an “as available” basis. We are not
          responsible for indirect losses, business interruptions or loss of data
          resulting from the use of our platform.
        </p>

        <h2>Changes to These Terms</h2>

        <p>
          We may update these Terms from time to time. Continued use of Cluster
          Clear means you accept the updated Terms.
        </p>

        <h2>Contact</h2>

        <p>support@clusterclear.app</p>
      </div>
    </div>
    <Footer/>
     </>
  );
}

export default Terms;